import React from 'react';
import MKTMonitorsPage from './MKTMonitorsPage';
import { connect } from 'react-redux';
import { reportActions } from '../../../../actions/report.actions';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import { bindActionCreators } from 'redux';
import lookupActions from '../../../../actions/lookup.actions';
import helper from '../../../../utils/helper';
import moment from 'moment';

class MKTMonitors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isFetching: false,
      departments: [],
      deptId: undefined,
      mktMonitors: [],
      openModal: false,
      selectedRow: null,
      errors: '',
      intervalId: null,
    };
    this.columns = [
      {
        dataField: 'id',
        text: 'ID',
        sort: true,
      },
      {
        dataField: 'sampleId',
        text: 'Sample ID',
        sort: true,
      },
      {
        dataField: 'sensorName',
        text: 'Sensor Name',
        sort: true,
      },
      {
        dataField: 'startTime',
        text: 'Start Time',
        sort: true,
        isDateTime: true,
        headerStyle: { width: 190 },
        formatter: (cell) => moment(cell).utc().format('MM/DD/yyyy HH:mm:ss'),
      },
      {
        dataField: 'notAvailable',
        text: 'Not Available',
        sort: true,
      },
      {
        dataField: 'calculatedMKT',
        text: 'MKT',
        sort: true,
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Edit MKT monitor',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/reports/mkt-monitors/edit-mkt-monitor/${this.state.deptId}/${row.id}`,
            );
          },
        },
        {
          name: 'Delete MKT monitor',
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
    this.defaultSorted = [
      {
        dataField: 'id',
        order: 'desc',
      },
    ];
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {
      errors: prevState.errors,
    };
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.report.mktMonitors !== prevState.mktMonitors) {
      state.mktMonitors = nextProps.report.mktMonitors;
    }
    if (nextProps.report.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.report.isFetching;
    }
    state.errors = helper.centralizeError([
      nextProps.lookup.errors,
      nextProps.report.error,
    ]);
    return Object.keys(state).length ? state : null;
  }
  componentDidMount() {
    this.setState(
      { loading: true },
      async () =>
        await this.props.lookupActions
          .getDepartments()
          .finally(() => this.setState({ loading: false })),
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.deptId !== prevState.deptId &&
      this.state.deptId !== undefined
    ) {
      clearInterval(this.state.intervalId);
      const intervalId = setInterval(async () => {
        await this.props.reportActions.getMktMonitors(this.state.deptId);
      }, 10000);
      this.setState({ intervalId });
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  onChangeDept = (deptId) => {
    this.setState(
      { deptId },
      async () => await this.props.reportActions.getMktMonitors(deptId),
    );
  };

  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteMktMonitor = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false },
      async () =>
        await this.props.reportActions
          .deleteMktMonitor(selectedRow.id)
          .then(
            async () =>
              await this.props.reportActions.getMktMonitors(this.state.deptId),
          ),
    );
  };
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <MKTMonitorsPage
        {...this.state}
        onChangeDept={this.onChangeDept}
        onFilter={this.onFilter}
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        ctxMenuOptions={this.ctxMenuOptions}
        openModal={this.state.openModal}
        onCancel={this.onCancel}
        onDeleteMktMonitor={this.onDeleteMktMonitor}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    report: state.report,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MKTMonitors);
